import {OKXConnectError} from "@okxconnect/core";

export class OKXConnectUiError extends OKXConnectError {
    constructor(message?: string) {
        super(1, message);
    }
}
